import React, { useState } from "react";
import { Button } from "controls";
import { lsUpdate } from "hooks";

const SwitchReg = ({ setShowForm, selRegDtls, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleSwitch = () => {
    setLoading(true);
    lsUpdate("activeReg", { ...selRegDtls });
    setLoading(false);
    setShowForm && setShowForm(false);
    onSuccess && onSuccess(selRegDtls);
  };

  return (
    <>
      <Button size="large" loading={loading} onClick={handleSwitch}>
        Switch
      </Button>
    </>
  );
};

export default SwitchReg;
